export enum ColourTags {
  RED = '0xfd7567',
  GREEN = '0x00e94e',
  YELLOW = '0xfffa00',
}
